import styled from 'styled-components';
import { TextField } from '@material-ui/core';

export default styled(TextField)`
  margin: 6px;
  width: 350px;
  max-width: 70vw;
`;
